export default "__VITE_ASSET__CUyu4uDQ__"